<script setup>
import { ref, useSlots } from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    closeable: {
        type: Boolean,
        default: true,
    },
    color: {
        type: String,
        default: 'red',
    }
});

const slots = useSlots()

const show = ref(props.show);

const close = () => {
    if (props.closeable) {
        show.value = !show.value;
    }
};
</script>

<template>
    <Transition leave-active-class="duration-200">
        <div v-show="show" class="border px-4 py-3 rounded relative" role="alert" :class="`bg-${props.color}-100 border-${props.color}-400 text-${props.color}-700`">

            <strong v-if="slots.title" class="block font-bold">
                <!-- Holy smokes! -->
                <slot name="title" />
            </strong>
            <span class="block sm:inline">
                <slot />
            </span>
            <span v-if="closeable" class="absolute top-0 bottom-0 right-0 px-4 py-3">
                <svg @click="close" :class="`fill-current h-6 w-6 text-${color}-500`" role="button"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <title>Close</title>
                    <path
                        d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                </svg>
            </span>
        </div>
    </Transition>
</template>